module.exports = global["jQuery"] = require("-!/var/lib/jenkins/workspace/Brands you love - Live - Bilden/frontend/src/web/node_modules/expose-loader/index.js?$!./jquery.js");


//////////////////
// WEBPACK FOOTER
// ./node_modules/jquery/dist/jquery.js
// module id = 2
// module chunks = 2